import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1974fc84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "tagsWrapper",
  class: "catalog-tags-filters__tags"
}
const _hoisted_2 = {
  key: 0,
  class: "catalog-tags-filters__title"
}
const _hoisted_3 = {
  ref: "tagList",
  class: "catalog-tags-filters__list"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "catalog-tags-filters__unroll-icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "desktop-actions" }
const _hoisted_7 = { class: "mobile-actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-action-close__icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-action-close__text" }, " Сбросить ", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-action-rollup__icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-action-rollup__text" }, " Свернуть ", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RolledTag = _resolveComponent("RolledTag")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["catalog-tags-filters", [
      {'catalog-tags-filters--invisible': !_ctx.filters.length},
      {'catalog-tags-filters--collapsed': _ctx.isRolled},
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.filters.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Выбор: "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: filter.id
          }, [
            (_ctx.isRolled && filter.filters?.length)
              ? (_openBlock(), _createBlock(_component_RolledTag, {
                  key: 0,
                  "data-is-main-filter": "",
                  filter: filter,
                  onDeselect: _cache[0] || (_cache[0] = (id, type) => _ctx.$emit('deselect', id, type))
                }, null, 8, ["filter"]))
              : (_openBlock(), _createBlock(_component_Tag, {
                  key: 1,
                  "data-is-main-filter": "",
                  "data-with-subfilters": !!filter.filters?.length,
                  filter: filter,
                  onDeselect: _cache[1] || (_cache[1] = (id, type) => _ctx.$emit('deselect', id, type))
                }, null, 8, ["data-with-subfilters", "filter"])),
            (filter.filters && !_ctx.isRolled)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filter.filters, (subfilter, index) => {
                  return (_openBlock(), _createBlock(_component_Tag, {
                    key: subfilter.id,
                    filter: subfilter,
                    "is-sub-tag": true,
                    "is-active": _ctx.isActiveFilterByGroupId(filter.id, subfilter.id),
                    "is-last-child": index === filter.filters.length - 1,
                    onSelectSubGroup: (id) => _ctx.$emit('selectSubGroup', filter.id, id)
                  }, null, 8, ["filter", "is-active", "is-last-child", "onSelectSubGroup"]))
                }), 128))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (_ctx.isRolled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "catalog-tags-filters__unroll",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unroll && _ctx.unroll(...args)))
            }, _hoisted_5))
          : _createCommentVNode("", true)
      ], 512)
    ], 512),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(['desktop-actions__toggle', {'desktop-actions__toggle--revert': _ctx.isOpen }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle')))
      }, null, 2),
      _createElementVNode("div", {
        class: "desktop-actions__reset",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reset')))
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "mobile-action-close",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('reset')))
      }, _hoisted_10),
      (!_ctx.isRolled && !_ctx.isNotShowingRollToggler)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "mobile-action-rollup",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('roll')))
          }, _hoisted_13))
        : _createCommentVNode("", true)
    ])
  ], 2))
}